import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivityErrorPageComponent } from './activity-error-page.component';
import { DlsButtonModule } from '@zelis/dls/button';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [ActivityErrorPageComponent],
  imports: [CommonModule, DlsButtonModule, TranslateModule],
  exports: [ActivityErrorPageComponent],
})
export class ActivityErrorPageModule {}
